/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BinaryFileType } from '../models/binary-file-type';
import { getConsigneeDeliveryNoteCombinedPdf } from '../fn/consignee/get-consignee-delivery-note-combined-pdf';
import { GetConsigneeDeliveryNoteCombinedPdf$Params } from '../fn/consignee/get-consignee-delivery-note-combined-pdf';

@Injectable({ providedIn: 'root' })
export class ConsigneeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getConsigneeDeliveryNoteCombinedPdf()` */
  static readonly GetConsigneeDeliveryNoteCombinedPdfPath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/complete-pdf';

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures and all images
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDeliveryNoteCombinedPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDeliveryNoteCombinedPdf$Response(params: GetConsigneeDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    const obs = getConsigneeDeliveryNoteCombinedPdf(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures and all images
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDeliveryNoteCombinedPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDeliveryNoteCombinedPdf(params: GetConsigneeDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    const resp = this.getConsigneeDeliveryNoteCombinedPdf$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

}
